import styled from 'styled-components';
import device from '../../mediaQueries';

const SearchInput = styled.input`
  &::placeholder {
    font-weight: lighter;
  }

  ${device.desktop`
  && {
    border-radius: 5px;
    text-align: left !important;
    height: 38px;
    width: 228px;
    border: solid 1px black;
    outline: none;
    padding: 0 30px 0 40px;
    &:focus {
      border: solid 1px #000000;
    }
  }`}

  ${device.mobile`
  && {
    border-radius: 0;
    background-color: #FFFFFF;
    -webkit-appearance: none;
    box-sizing: border-box;
    border: none;
    border-bottom: solid 2px #000000;
    font-size: 1em;
    margin-left: 0.5em;
    margin-right: 0.5em;
    margin-top: 60px;
    min-height: 2.5em;
    outline: none;
    padding: 13px 22px 13px 13px;
    padding-left: 25px;
    width: 75vw;
    &:focus {
      border-bottom: solid 2px #000000;
    }
  }`}
`;

export default SearchInput;
